import { render, staticRenderFns } from "./ReqtrasladoAnalisisComponent.vue?vue&type=template&id=23151aa5&"
import script from "./ReqtrasladoAnalisisComponent.vue?vue&type=script&lang=js&"
export * from "./ReqtrasladoAnalisisComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports